import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { LoginPage } from "@/pages/LoginPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { AssetsPage } from "@/pages/AssetsPage";
import { AlertsPage } from "@/pages/AlertsPage";
import { SecurityScorePage } from "@/pages/SecurityScorePage";
import { CompliancePage } from "@/pages/CompliancePage";
import { VulnerabilitiesPage } from "@/pages/VulnerabilitiesPage";
import { NACPage } from "@/pages/NACPage";
import { ThreatsPage } from "@/pages/ThreatsPage";
import { ThreatIntelPage } from "@/pages/ThreatIntelPage";
import { AutomationPage } from "@/pages/AutomationPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { WarRoomPage } from "@/pages/WarRoomPage";
import useAuthStore from "@/store/authStore";
import { Toaster } from "@/components/ui/sonner";

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuthStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

// Public Route (redirect to dashboard if authenticated)
function PublicRoute({ children }) {
  const { isAuthenticated } = useAuthStore();
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            } 
          />
          <Route 
            path="/forgot-password" 
            element={
              <PublicRoute>
                <ForgotPasswordPage />
              </PublicRoute>
            } 
          />
          <Route 
            path="/reset-password" 
            element={
              <PublicRoute>
                <ResetPasswordPage />
              </PublicRoute>
            } 
          />
          
          {/* Protected routes */}
          <Route 
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="/security-score" element={<SecurityScorePage />} />
            <Route path="/assets" element={<AssetsPage />} />
            <Route path="/nac" element={<NACPage />} />
            <Route path="/alerts" element={<AlertsPage />} />
            <Route path="/threats" element={<ThreatsPage />} />
            <Route path="/threat-intel" element={<ThreatIntelPage />} />
            <Route path="/vulnerabilities" element={<VulnerabilitiesPage />} />
            <Route path="/compliance" element={<CompliancePage />} />
            <Route path="/automation" element={<AutomationPage />} />
            <Route path="/war-room" element={<WarRoomPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/help" element={<DashboardPage />} />
          </Route>
          
          {/* Catch all - redirect to dashboard or login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
